import { hiddenUserData } from "helpers/hiddenData";
import { paths } from "helpers/paths";
import { columnName, formatValue, OVERALL_REPORT_VAT_TOGGLE_COLUMNS, REPORT_TYPES } from "helpers/reports";
import upperFirst from "lodash/upperFirst";
import Tooltip from "rc-tooltip";
import React from "react";
import { OverallReport } from "./overallReport";

export default class CounterpartiesReport extends OverallReport {
    tableExtraProps = () => {
        const { id, overallReportWithNds, organization } = this.props;
        const { columns } = this.props.data || {};
        const hiddenColumns = columns
            .filter((column) => {
                return (
                    column.isAdditionalColumn ||
                    column.isFooterData ||
                    column.propertyName === "CarLogistDisplayName" ||
                    (id === REPORT_TYPES.CounterpartiesReport && overallReportWithNds
                        ? OVERALL_REPORT_VAT_TOGGLE_COLUMNS.withoutNds.includes(column.propertyName)
                        : OVERALL_REPORT_VAT_TOGGLE_COLUMNS.withNds.includes(column.propertyName))
                );
            })
            .map(columnName);

        return {
            initialState: {
                groupBy: ["carLogistId"],
                hiddenColumns,
            },
            renderRowSubComponent: (row, isPrintForm) => {
                if (!row.original.bids || row.original.bids.length === 0) {
                    return null;
                }
                const tableProps = isPrintForm
                    ? {
                          className: "p-3 reports--bg-bluelight",
                          style: {
                              minWidth: "100%",
                              width: row.cells.reduce((acc, cell) => acc + cell.column.width, 0),
                          },
                      }
                    : {
                          className: "table-responsive",
                      };
                return (
                    <div {...tableProps}>
                        <table className="table table-sm mb-0 border-bottom border-secondary bg-secondary">
                            <thead>
                                <tr className="table-active">
                                    <th>#</th>
                                    <th>Заявка</th>
                                    <th>Внешний ID Заявки</th>
                                    <th>Организация</th>
                                    <th>Машина</th>
                                    <th>Маршрут</th>
                                    <th>Даты выполнения</th>
                                    <th>Активный, км</th>
                                    <th>ВАЛ</th>
                                    <th>Сред. вес, т</th>
                                    <th>{upperFirst(organization?.currencyData?.name)}/км</th>
                                    <th>{upperFirst(organization?.currencyData?.name)}/час</th>
                                </tr>
                            </thead>
                            <tbody>
                                {row.original.bids.map((item, index) => (
                                    <tr key={index} className={item.compoundBidId && "r-item__compound-bid"}>
                                        <td>{index + 1}</td>
                                        <td data-id={item.id}>
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={paths.bidShow("bid", item.id)}
                                            >
                                                {item.id}
                                            </a>
                                            {item.hasManualMileage && (
                                                <Tooltip overlay="Закрыта вручную">
                                                    <span className="pl-1 icon-uEA83-user-edit b-point__tooltip-icon" />
                                                </Tooltip>
                                            )}
                                            {item.compoundBidId && (
                                                <Tooltip overlay="Сборная заявка">
                                                    <i className="pl-1 b-table__compound-icon icon-uEA76-animation-outline" />
                                                </Tooltip>
                                            )}
                                            {item.isExpressBid && (
                                                <Tooltip overlay="Экспресс-заявка">
                                                    <i className="pl-1 icon-uEA90-bolt b-point__tooltip-icon" />
                                                </Tooltip>
                                            )}
                                            {item.hasEmulatedMileage && (
                                                <Tooltip overlay="В заявке присутствуют сэмулированные участки маршрута">
                                                    <i className="pl-1 icon-uEACB-emulated-route b-point__tooltip-icon" />
                                                </Tooltip>
                                            )}
                                        </td>
                                        <td data-externalid={item.id}>{item.externalId}</td>
                                        <td data-legal-person={item.id} data-legal-person-id={item.legalPersonId}>
                                            {item.legalPersonName}
                                        </td>
                                        <td data-carname={item.id}>{item.carName}</td>
                                        <td data-route={item.id}>{item.route}</td>
                                        <td data-executiondaterange={item.id}>{item.executionDateRange}</td>
                                        <td data-activemileage={item.id}>
                                            {formatValue(item.activeMileage, "double")}
                                        </td>
                                        <td data-overallbidprice={item.id}>
                                            {hiddenUserData(formatValue(item.overallBidPrice, "double"), {
                                                type: "price",
                                            })}
                                        </td>
                                        <td data-averageplanweight={item.id}>
                                            {formatValue(item.averagePlanWeight, "double")}
                                        </td>
                                        <td data-output={item.id}>
                                            {hiddenUserData(formatValue(item.output, "double"), {
                                                type: "pricePerVal",
                                            })}
                                        </td>
                                        <td data-rubperhour={item.id}>
                                            {hiddenUserData(formatValue(item.rubPerHour, "double"), {
                                                type: "pricePerVal",
                                            })}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            },
        };
    };
}
